export default "__VITE_ASSET__Dj1ZMmV6__"